<div class="filter-section-placeholder">
  <div class="filter-section-placeholder-header">
    <h4>{{ title }}</h4>
    <span class="coming-soon-tag">Coming soon</span>
  </div>
  <p class="filter-section-placeholder-description">{{ description }}</p>
</div>
